import { Divider, theme } from 'antd'
import React from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { OepTargetFileGenerationSection } from './components/OepTargetFileGenerationSection'
import { OepToggleSection } from './components/OepToggleSection'
import { OepXlsxUploadSection } from './components/OepXlsxUploadSection'

interface Props {
  readonly id: string
}

interface TabSection {
  readonly key: string
  readonly node: React.ReactNode
}

export function OpenEnrollmentTab({ id }: Props) {
  const { token } = theme.useToken()
  const { flags } = useFeatureFlags()
  const isGenerateTargetFileEnabled = Boolean(
    flags['admin.abp-5.show-generate-target-file']
  )
  const isAnalysisFileUploadEnabled = Boolean(
    flags['admin.abp.allow-analysis-file-upload']
  )

  // Ordered like the admin's workflow: generate the ABP-4 target file, then
  // upload the reviewed analysis file.
  const sections: TabSection[] = [
    { key: 'toggle', node: <OepToggleSection clientId={id} /> },
    ...(isGenerateTargetFileEnabled
      ? [
          {
            key: 'target-file',
            node: <OepTargetFileGenerationSection clientId={id} />,
          },
        ]
      : []),
    ...(isAnalysisFileUploadEnabled
      ? [
          {
            key: 'analysis-upload',
            node: <OepXlsxUploadSection clientId={id} />,
          },
        ]
      : []),
  ]

  return (
    <div
      id="open-enrollment-tab"
      style={{
        marginTop: 24,
        background: token.colorBgContainer,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG,
        padding: 24,
      }}
    >
      {sections.map((section, index) => (
        <React.Fragment key={section.key}>
          {index > 0 ? <Divider style={{ margin: '24px 0' }} /> : null}
          {section.node}
        </React.Fragment>
      ))}
    </div>
  )
}
